import { httpClient } from 'common-utils';
import { VoucherCode } from 'preflight-core';
import { z } from 'zod';

type VoucherStatus = z.infer<typeof VoucherStatus>;
export const VoucherStatus = z.enum([
  'EXPIRED',
  'NONE',
  'UNKNOWN',
  'VALID',
  'INVALID',
  'REDEEMED',
]);

const VoucherApiResponse = z.object({
  voucherStatus: VoucherStatus,
  message: z.string().optional(),
});

export type Voucher = z.infer<typeof Voucher>;
const Voucher = VoucherApiResponse.merge(
  z.object({ code: VoucherCode, message: z.string() }),
);

export function getVoucher({
  publisherId,
  journalId,
  voucherCode,
}: {
  publisherId: string;
  journalId: string;
  voucherCode: VoucherCode;
}): Promise<Voucher> {
  return httpClient
    .get(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/voucher?voucherId=${voucherCode}&publisherSlug=${publisherId}&journalSlug=${journalId}`,
    )
    .catch(() => ({
      voucherStatus: 'INVALID',
      message: 'The voucher you’re trying to apply is invalid',
    }))
    .then(VoucherApiResponse.parse)
    .then(({ voucherStatus, message }) => ({
      voucherStatus,
      message: message ?? fallbackMessages[voucherStatus],
      code: voucherCode,
    }));
}

const fallbackMessages: Record<VoucherStatus, string> = {
  EXPIRED: 'Invalid voucher. Voucher is expired',
  INVALID: 'Invalid voucher',
  NONE: '',
  REDEEMED: 'Invalid voucher. All downloads used',
  UNKNOWN: '',
  VALID: 'Voucher applied. Download your Paperpal-edited Word file for free',
} as const;
